<template>
  <div id="visitingAdmin" class="px-2 pt-2">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer absolute temporary right v-model="drawer" class="pa-2"
      style="top: 50px; bottom: 120px; height: auto" :class="{ displayDiv: isShow }">
      <v-form class="mx-2" ref="form">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete clearable :items="regionList" outlined dense hide-details label="区域"
              v-model="payload.regionCode" item-text="regionName" item-value="regionCode" @change="setRegion($event)"
              v-if="isAdmin"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2" v-if="!this.user.role?.includes('Sales')">
            <v-autocomplete :items="salesList" outlined hide-details dense label="销售姓名" clearable item-value="id"
              item-text="displayName" v-model="payload.salesId"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2" v-if="!this.user.role?.includes('Sales')">
            <v-menu v-model="pickStartDate" :close-on-content-click="false" :nudge-right="-60"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="payload.start" label="查询起始时间" :clearable="true" outlined hide-details dense
                  readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="payload.start" type="date" locale="zh"
                @input="pickStartDate = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2" v-if="!this.user.role?.includes('Sales')">
            <v-menu v-model="pickEndDate" :close-on-content-click="false" :nudge-right="-60" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="payload.end" label="查询结束时间" :clearable="true" outlined hide-details dense readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="payload.end" type="date" locale="zh" @input="pickEndDate = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
      <template v-slot:append>
        <v-row class="ma-0">
          <v-btn class="primary white--text" @click="clearSearchVisit()">清空搜索</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="searchVisit()">搜索</v-btn>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-form class="mx-2">
      <v-row class="ma-0">
        <div class="breadcrumb font-weight-black">
          查询结果条数{{ this.total }}
        </div>
        <v-spacer></v-spacer>

        <v-btn color="primary" dark v-if="!user.role?.includes('Sales') && !user.role?.includes('Sell-in Sales')" class="primary white--text"
          @click="exportVisiting">导出</v-btn>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <v-btn color="primary" dark @click.stop="drawer = !drawer" v-if="!dealerId">
          筛选
        </v-btn>
      </v-row>
    </v-form>
    <!-- <v-virtual-scroll
      :items="items"
      :item-height="140"
      id="visitingList"
      class="mt-5"
    > -->
    <EasyRefresh id="visitingList" class="mt-4" :userSelect="false" :onRefresh="onRefresh" :loadMore="loadMore"
      :autoLoad="isLoad" style="height: calc(100% - 95px)">
      <v-card v-for="(item) in items" :key="item.id" outlined tile height="100%" class="visitingInfo" :style="{
        'border-left-color': colors[item.readStatus],
      }">
        <v-card-text style="height: 100%" class="pa-0 px-2">
          <v-row class="ma-0" style="height: 100%">
            <v-col cols="11" class="pa-0">
              <v-list class="transparent">
                <v-list-item class="px-0">
                  <v-list-item-title> 拜访日期 </v-list-item-title>

                  <v-list-item-subtitle class="text-right">
                    {{ item.visitDate.slice(0, 10) }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title> 经销商编号 </v-list-item-title>

                  <v-list-item-subtitle class="text-right">
                    {{ item.dealer?.code }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title> 经销商名称 </v-list-item-title>

                  <v-list-item-subtitle class="text-right">
                    {{ item.dealerName }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title> 销售姓名 </v-list-item-title>

                  <v-list-item-subtitle class="text-right">
                    {{ item.salesName }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="1" class="pa-0 toDetail">
              <v-btn icon link @click="redirectToList(item)">
                <v-icon large>mdi-chevron-right</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template v-slot:footer>
        <ClassicsFooter />
      </template>
    </EasyRefresh>
    <!-- </v-virtual-scroll> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import api from "../../api/api";
export default {
  name: "VisitingList",
  components: {},
  data: () => ({
    breadcrumb: "",
    drawer: false,
    loading: false,
    items: [],
    total: 0,
    readColors: ["#D42027", "#599956"],
    salesList: [],
    regionList: [],
    pickStartDate: false,
    pickEndDate: false,
    payload: {
      regionCode: null,
      salesId: null,
      start: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substring(0, 10),
      end: new Date().toISOString().substring(0, 10)
    },
    colors: [
      "#D42027",
      "#C0C0C0",
    ],

    pageIndex: 0,
    pageSize: 10,
    isShow: false,
    isLoad: false,
    isFirst: true
  }),
  computed: {
    ...mapState(["category", "user"]),
    isAdmin() {
      return (
        this.user.role?.includes('HOD') ||
        this.user.role?.includes('RRS') ||
        this.user.role?.includes('SCN')
      );
    },
    dealerId() {
      return this.$route.query.dealer;
    },
  },
  created() {
    console.log(this.dealerId);
    // this.getVisitingDataByDealer();
    // if (this.dealerId) {
    //   this.getVisitingDataByDealer();
    // } else {
    //   this.getRegion();
    // }
    this.getRegion();
  },
  methods: {
    onRefresh: function (done) {
      this.isLoad = false;
      var self = this;
      var tmp = self.pageIndex * 10 - self.pageSize;
      if (tmp < 0) {
        this.message = {
          show: true,
          type: "info",
          text: "没有更多数据！",
        };
        done();
      } else {
        self.pageIndex = self.pageIndex - 1;
        self.getVisitData();
        done();
      }
    },
    loadMore: function (done) {
      if ((this.pageIndex + 2) * this.pageSize > this.total) {
        this.isLoad = true;
      }
      var self = this;
      var tmpTotal = (self.pageIndex + 1) * self.pageSize;
      if (tmpTotal <= self.total) {
        self.pageIndex = self.pageIndex + 1;
        self.getVisitData();
      } else {
        this.message = {
          show: true,
          type: "info",
          text: "没有更多数据！",
        };
      }
      done();
    },
    async getVisitData() {
      this.loading = true;
      // let userId = "";
      // if (this.user.role?.includes('Sales')) {
      //   userId = this.user.userId;
      // }
      if (this.isFirst) {

        api.visit
          .getVisitList2(`visit/find_by?pageIndex=${this.pageIndex}&pageSize=${this.pageSize
            }&regionCode=${this.payload.regionCode || ""
            }&salesId=${this.payload.salesId || ""}`)
          .then((res) => {
            const { data, status } = res?.data || {};
            if (status == 200 && data) {
              if (this.user.role?.includes('RM')) {
              this.items = data.list.map((item) => {
                return {
                  ...item,
                }
              }).filter(item => item?.salesId !== this.user.userId);
            } else {
                this.items = data.list.map((item) => {
                return {
                  ...item,
                };
              });
            }
            this.total = this.items.length;
            } else if (status == 200 && !data) {
              if (this.pageIndex > 0) {
                this.pageIndex = this.pageIndex - 1;
              }
              this.message = {
                show: true,
                type: "info",
                text: "没有更多数据！",
              };
            } else {
              this.items = [];
              this.message = {
                show: true,
                type: "info",
                text: "没有数据！",
              };
            }
          })
          .finally(() => {
            // this.isShow = false;
            // this.drawer = false;
            this.loading = false;
          });
      } else {
        api.visit
          .getVisitList2(`visit/find_by?pageIndex=${this.pageIndex}&pageSize=${this.pageSize
            }&regionCode=${this.payload.regionCode || ""
            }&salesId=${this.payload.salesId || ""}&start=${this.payload.start || ""
            }&end=${this.payload.end || ""}`)
          .then((res) => {
            const { data, status } = res?.data || {};
            if (status == 200 && data) {
              if (this.user.role?.includes('RM')) {
              this.items = data.list.map((item) => {
                return {
                  ...item,
                }
              }).filter(item => item?.salesId !== this.user.userId);
            } else {
                this.items = data.list.map((item) => {
                return {
                  ...item,
                };
              });
            }
            this.total = this.items.length;
            } else if (status == 200 && !data) {
              if (this.pageIndex > 0) {
                this.pageIndex = this.pageIndex - 1;
              }
              this.message = {
                show: true,
                type: "info",
                text: "没有更多数据！",
              };
            } else {
              this.items = [];
              this.message = {
                show: true,
                type: "info",
                text: "没有数据！",
              };
            }
          })
          .finally(() => {
            // this.isShow = false;
            // this.drawer = false;
            this.loading = false;
          });

      }
    },
    //导出日常拜访
    exportVisiting() {
      this.loading = true;
      this.payload.name = this.payload.name || "";
      if (this.isFirst) {
        api.visit
          .exportVisit({ regionCode: null, salesId: null, start: null, end: null })
          .then((res) => {
            if (
              res.data.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(res.data);
              link.download = "日常拜访记录";
              link.click();
            } else {
              alert("导出失败，请重试！");
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        api.visit
          .exportVisit(this.payload)
          .then((res) => {
            if (
              res.data.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(res.data);
              link.download = "日常拜访记录";
              link.click();
            } else {
              alert("导出失败，请重试！");
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }

    },



    ...mapActions(["SET_BACK"]),
    redirectToList(item) {
      if (this.dealerId) {
        this.$router.push({
          path: `/visiting/detail/${item.id}`,
          query: {
            dealer: this.dealerId,
          },
        });
      } else {
        this.$router.push({
          path: `/visiting/detail/${item.id}`,
          query: {
            end: this.payload.end,
            regionCode: this.payload.regionCode,
            salesId: this.payload.salesId,
            start: this.payload.start,
            visitId: item.id,
          },
        });
      }
    },
    searchVisit() {
      this.getVisitingData();
    },
    clearSearchVisit() {
      this.payload.regionCode = null;
      this.payload.salesId = null;
      this.payload.start = new Date(
        new Date().getTime() - 15 * 24 * 60 * 60 * 1000
      )
        .toISOString()
        .substring(0, 10);
      this.payload.end = new Date().toISOString().substring(0, 10);
      this.pickStartDate = false;
      this.pickEndDate = false;
      this.$refs.form.$forceUpdate();
      this.getVisitingData();
    },
    setRegion($event) {
      if ($event) {
        this.getSaleList();
      } else {
        this.salesList = [];
      }
    },
    getSaleList() {
      api.user
        .getUserWithRoleAndRegion("Sales", this.payload.regionCode, "Sell-in Sales")
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.salesList = data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setRegionForInit() {
      this.payload.regionCode = this.$route.query.regionCode || "";
      this.payload.salesId = this.$route.query.salesId || "";
      this.payload.start = this.$route.query.start || "";
      this.payload.end = this.$route.query.end || "";
      if (this.payload.salesId) {
        this.payload.salesId = Number(this.payload.salesId);
      }
    },
    getRegion() {
      api.pca.getRegion().then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.regionList = data;
          if (
            Object.prototype.hasOwnProperty.call(this.$route.query, "region") ||
            Object.prototype.hasOwnProperty.call(this.$route.query, "salesId")
          ) {
            this.payload.regionCode = this.$route.query.regionCode || "";
            this.setRegionForInit(this.payload.regionCode);
          } else if (!this.isAdmin) {
            this.setRegion(this.user.userRegionCode);
            this.payload.regionCode = this.user.userRegionCode;
          }
          this.getSaleList();
          //this.getVisitingData();

          this.getVisitingData();
        }
      });
    },
    async getVisitingDataByDealer() {
      this.loading = true;
      api.visit
        .getVisitWithFilter({
          dealerId: Number(this.dealerId),
          stagingFlag: 0,
        })
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.total = data.total;
            this.items = data.list.map((item) => {
              return {
                ...item,
              };
            });
          } else if (status == 200 && !data) {
            this.items = [];
            this.total = 0;
          } else {
            this.total = 0;
            this.items = [];
          }
        })
        .finally(() => {
          this.drawer = false;
          this.loading = false;
        });
    },
    async getVisitingData() {
      this.isFirst = false;
      this.loading = true;
      this.pageIndex = 0;
      this.pageSize = 10;
      api.visit
        .getVisitList2(`visit/find_by?pageIndex=${this.pageIndex}&pageSize=${this.pageSize
          }&regionCode=${this.payload.regionCode || ""
          }&salesId=${this.payload.salesId || ""}&start=${this.payload.start || ""
          }&end=${this.payload.end || ""}`)
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            
            if (this.user.role?.includes('RM')) {
              this.items = data.list.map((item) => {
                return {
                  ...item,
                }
              }).filter(item => item?.salesId !== this.user.userId);
            } else {
                this.items = data.list.map((item) => {
                return {
                  ...item,
                };
              });
            }
            this.total = this.items.length;
          } else if (status == 200 && !data) {
            this.items = [];
            this.total = 0;
          } else {
            this.total = 0;
            this.items = [];
          }
        })
        .finally(() => {
          this.drawer = false;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass">
#visitingAdmin
  height: calc(var(--vh, 1vh) * 100 - 48px)
  width: 100%
  .breadcrumb
    line-height: 36px
  #visitingList
    height: calc( 100% - 70px )
    .toDetail
      display: grid
      place-self: center
    .visitingInfo
      border-left-width: 5px
      border-left-style: solid
      .v-list-item
        min-height: 25px
        .v-list-item__title
          overflow: visible
        .v-list-item__subtitle
          overflow: visible
</style>
<style>
.displayDiv {
  display: none;
}
</style>
